import React from 'react'
// @ts-ignore
import AssetSidebarFilterDropdown from 'plugin-liverig/shared/asset/components/AssetSidebarFilterDropdown'
import styled from 'styled-components'
import { debounce } from '../../rigDashboards/utils';
import Select, { OnChangeValue } from 'react-select';
import i18n from 'live/services/i18n'
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { selectActiveOnly, selectFilter, setActiveOnly, setFilters, setLoading } from '../ducks/navigationSlice';
import { Box, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import Utils from 'live/lib/utils'
import ActionToggle from 'live/components/ui/action-toggle'

interface FilterProps {
    sideBarExpanded: boolean;
    sidebarWidth: number;
    dropdownFilters: { [k: string]: { value: string, label: string }[] };
}

const initialFilters = {
    project: [],
    site: [],
    well: [],
    wellbore: [],
    event: [],
    rig: [],
    section: [],
    label: [""],
    active: [false]
}

function useDebounce<T>(value: T, delay?: number): T {
    const [debouncedValue, setDebouncedValue] = React.useState<T>(value)
  
    React.useEffect(() => {
      const timer = setTimeout(() => setDebouncedValue(value), delay || 500)
  
      return () => {
        clearTimeout(timer)
      }
    }, [value, delay])
  
    return debouncedValue
}

const Filter: React.FC<FilterProps> = ({ sideBarExpanded, sidebarWidth, dropdownFilters }) => {
    const filters = useAppSelector((state) => selectFilter(state))
    const activeOnly = useAppSelector((state) => selectActiveOnly(state))
    const dispatch = useAppDispatch();

    const [overflow, setOverflow] = React.useState<string>('hidden')
    const [tempFilters, setTempFilters] = React.useState<NavigationFilters>(initialFilters)
    const [totalFilters, setTotalFilters] = React.useState<number>(0)
    const [textFilter, setTextFilter] = React.useState<string>(filters.label?.[0] ?? "")
    const [activeOnlyLocal, setActiveOnlyLocal] = React.useState(activeOnly)

    const dropdownFiltersRef = React.useRef(null);
    
    // const debouncedValue = useDebounce(textFilter, 500)

    // const textFilter = React.useMemo(() => {
    //     return filters.label?.[0] ?? ""
    // }, [filters])

    React.useEffect(() => {
        setTempFilters(filters)
        setTextFilter(filters.label?.[0] ?? "")
    }, [filters])

    React.useEffect(() => {
        setTotalFilters(Object.keys(tempFilters).filter(x => !["label", "active"].includes(x) && tempFilters[x].length > 0).reduce((acc, cV) => {
            return acc + tempFilters[cV].length     
        }, 0))
    }, [tempFilters])

    React.useEffect(() => {
        if (!sideBarExpanded) setOverflow('hidden')
        else debounce(() => setOverflow('visible'), 500)()
    }, [sideBarExpanded])

    const handleOnChangeSelect = (
        newValue: OnChangeValue,
        filter: string
    ) => {
        setTempFilters((state) => ({ ...state, [filter]: newValue.map(x => x.value) }))
    }

    const renderSelectContainer = (title, options, filter) => {
        return <StyledSelectContainer>
            <span className='SelectTitle'>
                {title}
            </span>
            <Select 
                closeMenuOnSelect={false}
                multi={true}
                options={options}
                value={tempFilters[filter]}
                onChange={(newValue) => handleOnChangeSelect(newValue, filter)}
                clearable={true}
                searchable={true}
                searchPromptText={i18n('Type to search')}
            />
        </StyledSelectContainer>
    }

    const onChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTextFilter(event.target.value)
    }

    const handleChangeActiveOnly = () => {
        dispatch(setLoading(true))
        setActiveOnlyLocal(!activeOnly);
        _.debounce(() => {
            dispatch(setActiveOnly(!activeOnly))
        }, 1)()
    };

    // React.useEffect(() => {
    //     dispatch(setLoading(true))
    //     dispatch(setFilters({...tempFilters, label: [debouncedValue]}))
    // }, [debouncedValue])

    return (
        <>
            {/* {
                totalFilters > 0 &&
                <NotificationBadge overflow={overflow} left={dropdownFiltersRef?.current?.componentNode?.offsetLeft + 20} top={dropdownFiltersRef?.current?.componentNode?.offsetTop + 1}>
                    {totalFilters > 99 ? 99 : totalFilters}
                </NotificationBadge>
            } */}
            <StyledFiltersContainer overflow={overflow}>
                <div style={{ width: "100%" }}>
                    <TextField 
                        variant="standard" 
                        fullWidth 
                        margin={"none"} 
                        InputProps={{
                            startAdornment: <SearchIcon classes={{ root: "searchIcon" }} onClick={() => {
                                dispatch(setLoading(true))
                                _.debounce(() => {
                                    dispatch(setFilters({...tempFilters, label: [textFilter]}))
                                }, 1)()
                            }}/>,
                            endAdornment: <CloseIcon style={{ display: textFilter.length > 0 ? "block" : "none" }} onClick={() => {
                                dispatch(setLoading(true))
                                _.debounce(() => {
                                    dispatch(setFilters({...tempFilters, label: [""]}))
                                }, 1)()
                            }}
                            classes={{ root: "closeIcon" }}/>,
                            disableUnderline: true,
                            classes:{
                                input: "noBorder", 
                                notchedOutline: "noBorder",
                                focused: "focused",
                                formControl: "formControl"
                            }
                        }}
                        classes={{
                            root: "noBorder"
                        }}
                        placeholder={"Type + Enter to search"}
                        value={textFilter}
                        onChange={onChangeFilter}
                        onKeyDown={(event) => {
                            if (event.key == "Enter" && textFilter.length >= 3) {
                                dispatch(setLoading(true))
                                _.debounce(() => {
                                    dispatch(setFilters({...tempFilters, label: [textFilter]}))
                                }, 1)()
                            }
                        }}
                    />
                </div>

                {/* <StyledSidebarFilterDropdown
                    ref={dropdownFiltersRef}
                    sidebarWidth={sidebarWidth}
                    isMobile={Utils.isMobile()}
                    overflow={overflow}
                    onApply={() => {
                        dispatch(setFilters(tempFilters))
                    }}
                    onHide={() => null}
                    onCancel={() => {
                        setTempFilters(filters)
                    }}
                >
                    <StyledClearContainer>
                        <span onClick={() => setTempFilters(initialFilters)}>Clear all</span>
                    </StyledClearContainer>
                    {renderSelectContainer("Project", dropdownFilters["project"], "project")}
                    {renderSelectContainer("Site", dropdownFilters["site"], "site")}
                    {renderSelectContainer("Well", dropdownFilters["well"], "well")}
                    {renderSelectContainer("Wellbore", dropdownFilters["wellbore"], "wellbore")}
                    {renderSelectContainer("Event", dropdownFilters["event"], "event")}
                    {renderSelectContainer("Rig", dropdownFilters["rig"], "rig")}
                    {renderSelectContainer("Section", dropdownFilters["section"], "section")}
                </StyledSidebarFilterDropdown> */}
            </StyledFiltersContainer>

            <div style={{ display: "flex", overflow: "hidden", paddingLeft: "9px", fontSize: "13px", marginTop: "13px" }}>
                <ActionToggle 
                    onChange={handleChangeActiveOnly}
                    elLeft={<span>Active only</span>}
                    elRight={<span>Active only</span>}
                    active={activeOnlyLocal}
                    disabled={false}
                />
                <span>Active only</span>
            </div>
        </>
    )
}

export default Filter;

const NotificationBadge = styled.div<{ overflow: string, left: number, top: number }>`
    position: absolute;
    top: ${props => props.top}px;
    left: ${props => props.left}px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: var(--static-red-500);
    color: var(--static-gray-0);
    display: ${props => props.overflow == "hidden" ? "none" : "flex"};
    z-index: 999;
    justify-content: center;
    align-items: center;
`

const StyledFiltersContainer = styled.div<{ overflow: string }>`
    display: flex;
    overflow: ${props => props.overflow};
    border-bottom: 1px solid var(--gray-300);
    border-top: 1px solid var(--gray-300);
    height: 38px;

    .noBorder {
        border: none;
        height: 35px;
        background: var(--gray-200);

        :focus {
            background-color: var(--gray-0);
        }
    }

    .focused {
        background-color: var(--gray-0);
    }

    .searchIcon {
        cursor: pointer;
        height: 1.3em;
        width: 1.3em;
        fill: var(--gray-600);
    }

    .closeIcon {
        width: 16px;
        height: 24px;
        margin-right: 10px;
        fill: var(--gray-600);
        cursor: pointer;
    }

    .formControl {
        padding-left: 5px;
    }
`

const StyledSidebarFilterDropdown = styled(AssetSidebarFilterDropdown)<{ overflow: string, sidebarWidth: number, isMobile: boolean }>`
    display: flex;
    width: 32px;
    height: 36px;
    border-left: 1px solid var(--gray-300);
    border-bottom: none;
    padding: 0;
    justify-content: center;
    
    > div:first-child {
        overflow: visible;
        padding: 0px;
        flex: unset;

        > i {
            margin-left: 3px;
            font-weight: 900;
            color: var(--gray-600);
            font-size: 14px;
        }

        div {
            display: none;
        }

        > i:nth-of-type(2) {
            display: none;
        }
    }

    > div:nth-of-type(2) {
        position: fixed;
        top: ${props => props.isMobile ? "123px" : "104px"};
        left: 0px;
        width: ${props => props.sidebarWidth}px;
        ${props => props.isMobile ? "height: calc(100% - 122px)" : ""};
        overflow-y: auto;
    }

    > div > div {
        padding: 4px;
        > span {
            font-size: 11px;
        }
    }
    .divider {
        margin-top: 0px;
    }
    .btnApply {
        font-size: 13px;
        margin-left: 20px;
        border-radius: 3px;
        width: 64px;
        height: 24px;
    }
    .btnCancel {
        font-size: 13px;
        border-radius: 3px;
        width: 64px;
        height: 24px;
    }
`

const StyledClearContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 10px 0px 10px;
    align-items: end;

    span {
        cursor: pointer;
    }
`

const StyledSelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;

    .Select-control {
        margin: 0px;
        width: 100%;
        border-radius: 5px;
        background: var(--gray-100);
    }

    .SelectTitle {
        font-size: 12px;
        font-weight: 600;
        line-height: 13px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 5px;
    }

    .Select-placeholder {
        left: 10px;
    }

    .Select-menu-outer {
        z-index: 9998;
        height: 100px;
        width: 100%;
        margin-left: 0px;
        margin-top: 0px;
        max-height: 100px;
        overflow: visible;
    }

    .Select-menu {
        max-height: 150px;
        border: 1px solid var(--gray-400);
        border-top: none;
    }
`